export default "__VITE_ASSET__beb0d66b__"